import * as React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';


interface ReportColumnProps {
  selectedUserId: number | null;
  selectedStorageId: number | null;
  getReportsLoading: boolean;
  reports: VptReport[];
}

const ReportTypeColumn: React.FC<ReportColumnProps> = ({
  selectedUserId,
  selectedStorageId,
  getReportsLoading,
  reports,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Grid size={{ xs: 3 }} sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
      {!selectedUserId ? (
        <Box
          sx={{
            alignItems: 'center',
            ...theme.typography.placeHolderFont,
          }}
        >
          {t('reports:t.noReports')}
        </Box>
      ) : selectedStorageId === null ? (
        <Box
          sx={{
            alignItems: 'center',
            ...theme.typography.placeHolderFont,
          }}
        >
          {t('storages:t.selectStorage')}
        </Box>
      ) : getReportsLoading ? (
        <Typography variant="body2" sx={{ p: 1 }}>{t('nav:loading')}</Typography>
      ) : (
        reports.map((report) => (
          <Box
            key={report.id}
            sx={{
              display: 'flex',
              height: '30px',
              minHeight: '30px',
              paddingLeft: '12px',
              alignItems: 'center',
              gap: '10px',
              alignSelf: 'stretch',
              ...theme.typography.usersFontTitle,
              mb: 1,
            }}
          >
            {report.inventory ? t('reports:t.inventory') : 'Stocking'}
          </Box>
        ))
      )}
    </Grid>
  );
};

export default ReportTypeColumn;
